import { Button, Typography, Space } from "antd";
import { GoogleOutlined } from "@ant-design/icons";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { signInWithGoogle, supabase } from "../lib/supabase";
import { AccessCodeModal } from "../components/AccessCodeModal";

const { Title, Text } = Typography;

export default function SignIn(){
    const [loading, setLoading] = useState(false);
    const [showAccessCodeModal, setShowAccessCodeModal] = useState(false);
    const [userId, setUserId] = useState<string>('');
    const navigate = useNavigate();

    useEffect(() => {
        // Check if user is already signed in
        const checkSession = async () => {
            const { data: { session } } = await supabase.auth.getSession();
            if (session?.user) {
                setUserId(session.user.id);
                
                // Check if user profile exists and is activated
                const { data: profile } = await supabase
                    .from('profiles')
                    .select('activated')
                    .eq('id', session.user.id)
                    .single();

                if (profile && profile.activated) {
                    navigate('/');
                } else if (profile && !profile.activated) {
                    setShowAccessCodeModal(true);
                }
            }
        };

        // Handle OAuth callback
        supabase.auth.onAuthStateChange(async (event, session) => {
            if (event === 'SIGNED_IN' && session?.user) {
                setUserId(session.user.id);
                
                // Check if profile exists, if not create it
                const { data: existingProfile } = await supabase
                    .from('profiles')
                    .select('*')
                    .eq('id', session.user.id)
                    .single();

                if (!existingProfile) {
                    // Profile will be created by trigger, but we can wait a moment
                    await new Promise(resolve => setTimeout(resolve, 500));
                }

                // Check activation status
                const { data: profile } = await supabase
                    .from('profiles')
                    .select('activated')
                    .eq('id', session.user.id)
                    .single();

                if (profile && profile.activated) {
                    navigate('/');
                } else {
                    setShowAccessCodeModal(true);
                }
            }
        });

        checkSession();
    }, [navigate]);

    const handleGoogleSignIn = async () => {
        setLoading(true);
        try {
            const { error } = await signInWithGoogle();
            if (error) {
                console.error('Sign in error:', error);
                // Error will be handled by auth state change
            }
        } catch (err) {
            console.error('Unexpected error:', err);
        } finally {
            setLoading(false);
        }
    };

    const handleAccessCodeSuccess = () => {
        setShowAccessCodeModal(false);
        navigate('/');
    };

    return(
        <div style={{ maxWidth: "1200px", margin: "0 auto", width: "100%", paddingTop: "80px" }}>
            <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
                <Title level={1} style={{ color: "#032539", marginBottom: 8 }}>
                    Welcome to Twinfinity
                </Title>
                <Text style={{ color: "#1C768F", marginBottom: 32, fontSize: "16px" }}>
                    Sign in with Google to get started
                </Text>
                <Space direction="vertical" size="large" style={{ width: "100%", maxWidth: "400px" }}>
                    <Button 
                        type="primary" 
                        icon={<GoogleOutlined />}
                        onClick={handleGoogleSignIn}
                        loading={loading}
                        size="large"
                        block
                        style={{
                            backgroundColor: "#032539",
                            borderColor: "#032539",
                            color: "#FbF3F2",
                            height: "48px",
                            fontSize: "16px"
                        }}
                    >
                        Sign in with Google
                    </Button>
                </Space>
            </div>

            {userId && (
                <AccessCodeModal
                    open={showAccessCodeModal}
                    onSuccess={handleAccessCodeSuccess}
                    onCancel={() => setShowAccessCodeModal(false)}
                    userId={userId}
                />
            )}
        </div>
    )
}